import { useState, useContext } from 'react';
import { Button, Flex, Flexed, Input, Label, PhoneNumber, Scroll, Selectbox, Textarea, Wrap } from '../../utilities/Shared';
import States from '../../utilities/States';
import { SalesReps, CSRReps } from '../../utilities/Reps';
import BillingTerms from '../../utilities/BillingTerms';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { toast } from 'react-toastify';
import UserContext from '../../Context/UserContext';

const NewCustomer = ({ onCancel, setReset }) => {
  const userInfo = useContext(UserContext);
  const stat = localStorage.getItem('defaultCustomer');
  const [info, setInfo] = useState({
    state: 'FL',
    pros: stat === '2' ? '0' : '1', // Use string to match API expectation
    terms: 'Net 30',
    taxexempt: 'No',
    sales: userInfo.userInfo._id,
    name: '',
    dba: '',
    contact: '',
    contactemail: '',
    contactphone: '',
    address1: '',
    address2: '',
    city: '',
    zip: '',
    mainphone: '',
    fax: '',
    website: '',
    notes: '',
    csr: '',
  });
  const [disalesave, setDisalesave] = useState(false);

  const addCustomer = async (e) => {
    e.preventDefault();
    if (!info.name.trim() || !info.contact.trim()) {
      toast.error('Company Name and Contact Person are required.');
      return;
    }
    setDisalesave(true);
    let address = [];
    let contacts = [];

    if (info.address1.trim()) {
      address = {
        address1: info.address1.trim(),
        address2: info.address2.trim(),
        city: info.city.trim(),
        state: info.state,
        zip: info.zip.trim(),
        itemid: uuidv4(),
        name: info.name.trim(),
      };
    }

    if (info.contact.trim()) {
      contacts = {
        name: info.contact.trim(),
        contactid: uuidv4(),
        email: info.contactemail.trim(),
        officephone: info.contactphone.trim(),
      };
    }

    const payload = {
      name: info.name.trim(),
      dba: info.dba.trim(),
      mainphone: info.mainphone.trim(),
      fax: info.fax.trim(),
      address,
      website: info.website.trim(),
      notes: info.notes.trim(),
      custrep: info.csr,
      salesrep: info.sales,
      taxexempt: info.taxexempt,
      billingterms: info.terms,
      contacts,
      mainlocation: address.itemid || '',
      maincontact: contacts.contactid || '',
      pros: info.pros,
    };

    try {
      const res = await axios.post('https://highgroundapi.herokuapp.com/customers/add', payload);
      await slip(res.data, address, contacts);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to add customer.');
      setDisalesave(false);
    }
  };

  const slip = async (data, address, contacts) => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    };

    const tr = {
      companyid: data.company_id,
      name: data.name,
      phone: data.mainphone,
      notes: data.notes,
      website: data.website,
      custrep: data.custrep,
      salesrep: data.salesrep,
      taxexempt: data.taxexempt,
      billingterm: data.billingterms,
      pros: data.pros,
      ...(address.address1 && { address1: address.address1 }),
      ...(address.address2 && { address2: address.address2 }),
      ...(address.city && { city: address.city }),
      ...(address.state && { state: address.state }),
      ...(address.zip && { zip: address.zip }),
      ...(address.itemid && { locationid: address.itemid }),
      ...(contacts.name && { contact: contacts.name }),
      ...(contacts.contactid && { contactid: contacts.contactid }),
    };

    try {
      await axios.post('https://highgroundsoftware.com/dash/dashboard/php/addcustomer.php', tr, config);
      toast.success('Customer added successfully!');
      setReset(true); // Trigger refresh
     
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to sync customer data.');
    } finally {
      setDisalesave(false);
      onCancel(); // Close modal
    }
  };

  return (
    <Wrap bgcolor="#0E425A">
      <Flexed>
        <Flex textAlign="center" fontSize="1.7rem" fontWeight="bold" padding="0px 0px 20px 0px">
          Add {stat === '2' ? 'Prospect' : 'Customer'}
        </Flex>
      </Flexed>
      <form onSubmit={addCustomer}>
        <Scroll height="350px">
          <Flexed fontWeight="bold" letterSpacing="1px" gap="20px" padding="0px 20px 20px 20px">
            <Flex>
              <Flexed flexDirection="column">
                <Flex>
                  <Label>Company Name*</Label>
                  <Input value={info.name} onChange={(e) => setInfo({ ...info, name: e.target.value })} required />
                </Flex>
                <Flex>
                  <Label>Company DBA</Label>
                  <Input value={info.dba} onChange={(e) => setInfo({ ...info, dba: e.target.value })} />
                </Flex>
                <br />
                <Flex>
                  <Label>Contact Person*</Label>
                  <Input value={info.contact} onChange={(e) => setInfo({ ...info, contact: e.target.value })} required />
                </Flex>
                <Flex>
                  <Label>Email</Label>
                  <Input
                    type="email"
                    value={info.contactemail}
                    onChange={(e) => setInfo({ ...info, contactemail: e.target.value })}
                  />
                </Flex>
                <Flex>
                  <Label>Phone</Label>
                  <Input
                    value={PhoneNumber(info.contactphone)}
                    onChange={(e) => setInfo({ ...info, contactphone: e.target.value })}
                  />
                </Flex>
                <br />
                <Flex flex="2">
                  <Label>Address 1</Label>
                  <Input value={info.address1} onChange={(e) => setInfo({ ...info, address1: e.target.value })} />
                </Flex>
                <Flex flex="2">
                  <Label>Address 2</Label>
                  <Input value={info.address2} onChange={(e) => setInfo({ ...info, address2: e.target.value })} />
                </Flex>
                <Flex flex="1.5">
                  <Label>City</Label>
                  <Input value={info.city} onChange={(e) => setInfo({ ...info, city: e.target.value })} />
                </Flex>
                <Flexed>
                  <Flex>
                    <Label>State</Label>
                    <States value={info.state} onChange={(e) => setInfo({ ...info, state: e.target.value })} />
                  </Flex>
                  <Flex>
                    <Label>Zip</Label>
                    <Input value={info.zip} onChange={(e) => setInfo({ ...info, zip: e.target.value })} />
                  </Flex>
                </Flexed>
              </Flexed>
            </Flex>
            <Flex>
              <Flexed flexDirection="column">
                <Flex>
                  <Label>Sales Rep</Label>
                  <SalesReps value={info.sales} onChange={(e) => setInfo({ ...info, sales: e.target.value })} />
                </Flex>
                <Flex>
                  <Label>CSR</Label>
                  <CSRReps value={info.csr} onChange={(e) => setInfo({ ...info, csr: e.target.value })} />
                </Flex>
                <br />
                <Flexed>
                  <Flex>
                    <Label>Tax Exempt</Label>
                    <Selectbox value={info.taxexempt} onChange={(e) => setInfo({ ...info, taxexempt: e.target.value })}>
                      <option value="No">No</option>
                      <option value="Yes">Yes</option>
                    </Selectbox>
                  </Flex>
                  <Flex>
                    <Label>Billing Terms</Label>
                    <BillingTerms value={info.terms} onChange={(e) => setInfo({ ...info, terms: e.target.value })} />
                  </Flex>
                </Flexed>
                <Flexed>
                  <Flex>
                    <Label>Status</Label>
                    <Selectbox value={info.pros} onChange={(e) => setInfo({ ...info, pros: e.target.value })}>
                      <option disabled value="">
                        Select Status
                      </option>
                      <option value="0">Prospect</option>
                      <option value="1">Customer</option>
                    </Selectbox>
                  </Flex>
                  <Flex></Flex>
                </Flexed>
              </Flexed>
            </Flex>
          </Flexed>
          <Button
            type="submit"
            position="absolute"
            bottom="20px"
            fontWeight="bold"
            bgcolor="#F1F1F2"
            color="#303030"
            right="15%"
            padding="8px 40px"
            disabled={disalesave}
          >
            {disalesave ? 'Please Wait...' : 'Submit'}
          </Button>
        </Scroll>
      </form>
    </Wrap>
  );
};

export default NewCustomer;